import {
  Component,
  computed,
  inject,
  input,
  OnInit,
  Signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { RosterAbsenceService } from '../../services/roster-absence.service';
import { Absence } from '../../types/absence';
import { AbsenceMobiscrollHostComponent } from './absence-mobiscroll-host.component';

@Component({
  selector: 'soft-absence',
  imports: [AbsenceMobiscrollHostComponent],
  template: `
    @defer {
      <soft-absence-mobiscroll-host [absence]="absence()" />
    }
  `,
  styleUrl: './absence.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [],
})
export class AbsenceComponent implements OnInit {
  private readonly absenceService = inject(RosterAbsenceService);

  // private readonly params = signal({});
  readonly size = input<DOMRect | null>();

  readonly absence: Signal<Absence[]> = computed(() => this.absenceService.all());

  ngOnInit(): void {
    // this.absenceService.registerParams(this.params);
  }
}
